import { useCallback, useState } from "react";
import { useAppDispatch } from "../../../../../../../store";
import { FormInstance } from "antd";
import { useDisableByPermission } from "../../../../../../../lib/hooks/useDisableByPermission";
import { saveMailingSettings } from "../../../../../../../acions/accounts/contracts";

export const useSave = (
  form: FormInstance,
  contractId: string,
  reloadData: () => void,
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const dispatch = useAppDispatch();

  const [isDisabled, setIsDisabled] = useState<boolean>(false);

  useDisableByPermission("Contracts", setIsDisabled, "ModifyMailing");

  const onSave = useCallback(async () => {
    try {
      setIsDisabled(true);

      const request = await form.validateFields();

      const { lateNoticePayers, lateNoticePayees } = request;

      if (!lateNoticePayers) {
        delete request.latePayerDays;
      }

      if (!lateNoticePayees) {
        delete request.latePayeeDays;
      }

      await Promise.resolve(dispatch(saveMailingSettings(request, contractId)));

      setIsDisabled(false);
      setIsOpen(false);
      reloadData();
    } catch (e: any) {
      setIsDisabled(false);
    }
  }, [contractId, dispatch, form, reloadData, setIsOpen]);

  return { isDisabled, onSave };
};
